import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import NuevoStroCargasLight from '../components/nuevoStroCargas/Light/NuevoStroCargasLight';
import NuevoStroCargasDark from '../components/nuevoStroCargas/Dark/NuevoStroCargasDark';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Reclamo from './Reclamo';
import { ThemeContext } from '../context/Theme';
import AiChatWidget from '../components/AiChatWidget/AiChatWidget';
import { renameSharepointFolder, nombreCarpetaStro } from '../components/AiChatWidget/sharepointService';
export default function NuevoStroCargas() {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const id = useParams().id;
  useEffect(() => {
    localStorage.setItem('id', id);
  }, []);
  const [cookies] = useCookies(['user'], ['asignado']);
  const asignado = cookies.asignado;
  const [denuncia, setDenuncia] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [obs, setObs] = useState();
  const [responsabilidad, setResponsabilidad] = useState([]);
  const [denunciaParaSicobe, setDenunciaParaSicobe] = useState(null);
  const [frente, setFrente] = useState({});
  const [sicobe, setSicobe] = useState([]);
  const [pagosAnteriores1, setPagosAnteriores1] = useState([]);
  const [cobert, setCobert] = useState('');
  const [carga2, setCarga2] = useState(false);
  const [alerta, setAlerta] = useState(0);
  const alerta1 = useRef(false);
  const [opacity, setOpacity] = useState(0);
  const [estados, setEstados] = useState([]);
  const [estadosCodigos, setEstadosCodigos] = useState([]);
  const [carga3, setCarga3] = useState(false);
  const [planillaReclamos, setPlanillaReclamos] = useState([]);
  const [carga4, setCarga4] = useState(false);
  //reclamo
  const [reclamo3ro, setReclamo3ro] = useState([]);
  const [stro, setStro] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const resDenuncia = await axios.get(`https://back.agsseguros.online/api/carga/pruebaCargaSinNada/${id}`);
        setDenuncia(resDenuncia.data);
        if (resDenuncia.data.idReclamo != null) {
          const resReclamo3ro = await axios.get(`https://reclamosback.agsseguros.online/apiReclamos/empleadosSolicitudes/reclamo/${resDenuncia.data.idReclamo}`);
          setReclamo3ro(resReclamo3ro.data);
          const resStro = await axios.get(`https://reclamosback.agsseguros.online/apiReclamos/empleadosSolicitudes/stroParaReclamo/${resDenuncia.data.nroStro}`);
          setStro(resStro.data);
        }
        setResponsabilidad(resDenuncia.data.cobert);
        setObs(resDenuncia.data.obsPrevias);
        setCargando(true);
        const resEstados = await axios.get(`https://back.agsseguros.online/api/estados/estadosContractuales/${id}`);
        setEstados(resEstados.data);
        const estadosCod = await axios.get(`https://back.agsseguros.online/api/estados/codigosParaEstado/${id}`);
        setEstadosCodigos(estadosCod.data);
        setCarga3(true);
        const resSicobe = await axios.get(`https://back.agsseguros.online/api/tieneCobertura/${id}`);
        setSicobe(resSicobe.data);
        const duplicados = resDenuncia.data.duplicados !== undefined ? resDenuncia.data.duplicados : null;
        if (duplicados !== null && duplicados.length > 0) {
          setAlerta(1);
        }
        // pagos que existen
        const pagos = resSicobe.data.pagos;
        // plan de pagos
        const arrayFechaLimite = resSicobe.data.fechaLimiteWe;
        const fechaStro = new Date(resSicobe.data.fechaStro);
        const pagosAnteriores = [];
        // por cada elemento del array fechaLimite (plan de pagos), si la fecha del stro fue mayor que la fecha limite, se pushea dicho elemento
        for (let i = 0; i < arrayFechaLimite.length; i++) {
          if (i === 0) {
            pagosAnteriores.push([i]);
          } else {
            if (new Date(arrayFechaLimite[i]) < fechaStro) {
              pagosAnteriores.push([i]);
            }
          }
        }
        setPagosAnteriores1(pagosAnteriores);
        const totalImporteFechaStro = pagos
          .slice(0, pagosAnteriores1.length)
          .map(item => parseFloat(item?.pga_importe) || 0)
          .reduce((acc, importe) => acc + importe, 0);
        const totalImporteEsperado = (parseFloat(pagos[0]?.pga_importe) || 0) * pagosAnteriores1.length;
        if (pagos.length === 0) {
          setCobert('CON COBERTURA');
        } else if (pagos[0]?.pga_mp === 'TA') {
          setCobert('CON COBERTURA');
        } else if (totalImporteFechaStro !== totalImporteEsperado) {
          setCobert('EN REVISION');
        } else if (pagosAnteriores.length > 0 && pagosAnteriores.length <= pagos.length) {
          const ultimoPagoAnterior = pagos[pagosAnteriores.length - 1];
          const pgaFechaAlta = new Date(ultimoPagoAnterior.pga_fliqags);
          const fechaLimite = new Date(arrayFechaLimite[pagosAnteriores.length - 1]);
          if (pgaFechaAlta <= fechaLimite) {
            setCobert('CON COBERTURA');
          } else if (pgaFechaAlta > fechaLimite) {
            if (fechaStro >= pgaFechaAlta) {
              setCobert('CON COBERTURA');
            } else {
              setCobert('EN REVISION');
            }
          }
        } else {
          setCobert('EN REVISION');
        }
        const resFrente = await axios.get(`https://back.agsseguros.online/api/frente/${id}`);
        setFrente(resFrente.data);
        setCarga2(true);
        const resReclamo = await axios.get(`https://back.agsseguros.online/api/planillaReclamos/reclamo/${resDenuncia.data.id}`);
        setPlanillaReclamos(resReclamo.data);
        setCarga4(true);
      } catch (error) {
        console.error('Error fetching data', error);
      }
    };
    fetchData();
  }, [id]);
  const today = new Date();
  let day = today.getDate();
  let month = today.getMonth() + 1;
  const year = today.getFullYear();
  day = day < 10 ? '0' + day : day;
  month = month < 10 ? '0' + month : month;
  const formattedDate = day + '/' + month + '/' + year;
  function getCurrentTime() {
    const now = new Date();
    let hour = now.getHours();
    let minute = now.getMinutes();
    minute = minute < 10 ? '0' + minute : minute;
    return hour + ':' + minute;
  }
  const currentTime = getCurrentTime();
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }
  const [check, setChecked] = useState({
    fotos: false,
    cedula: false,
    croquis: false,
    relato: false,
    danios: false,
    registro: false,
    denunciaPol: false,
  });
  const [docu, setDocu] = useState({
    fotos: '',
    cedula: '',
    croquis: '',
    relato: '',
    danios: '',
    registro: '',
    denunciaPol: '',
    otros: '',
  });
  function handleChangeFotos(e) {
    setChecked(prevState => ({ ...prevState, fotos: e.target.checked }));
    if (!check.fotos) {
      setDocu(prevState => ({
        ...prevState,
        fotos: 'Fotos \n',
      }));
    } else if (check.fotos) {
      setDocu(prevState => ({
        ...prevState,
        fotos: '',
      }));
    }
  }
  function handleChangeCedula(e) {
    setChecked(prevState => ({ ...prevState, cedula: e.target.checked }));
    if (!check.cedula) {
      setDocu(prevState => ({
        ...prevState,
        cedula: 'Cedula \n',
      }));
    } else if (check.cedula) {
      setDocu(prevState => ({
        ...prevState,
        cedula: '',
      }));
    }
  }
  function handleChangeCroquis(e) {
    setChecked(prevState => ({ ...prevState, croquis: e.target.checked }));
    if (!check.croquis) {
      setDocu(prevState => ({
        ...prevState,
        croquis: 'Croquis \n',
      }));
    } else if (check.croquis) {
      setDocu(prevState => ({
        ...prevState,
        croquis: '',
      }));
    }
  }
  function handleChangeRelato(e) {
    setChecked(prevState => ({ ...prevState, relato: e.target.checked }));
    if (!check.relato) {
      setDocu(prevState => ({
        ...prevState,
        relato: 'Relato \n',
      }));
    } else if (check.relato) {
      setDocu(prevState => ({
        ...prevState,
        relato: '',
      }));
    }
  }
  function handleChangeDanios(e) {
    setChecked(prevState => ({ ...prevState, danios: e.target.checked }));
    if (!check.danios) {
      setDocu(prevState => ({
        ...prevState,
        danios: 'Daños \n',
      }));
    } else if (check.danios) {
      setDocu(prevState => ({
        ...prevState,
        danios: '',
      }));
    }
  }
  function handleChangeRegistro(e) {
    setChecked(prevState => ({ ...prevState, registro: e.target.checked }));
    if (!check.registro) {
      setDocu(prevState => ({
        ...prevState,
        registro: 'Registro \n',
      }));
    } else if (check.registro) {
      setDocu(prevState => ({
        ...prevState,
        registro: '',
      }));
    }
  }
  function handleChangeDenunciaPol(e) {
    setChecked(prevState => ({
      ...prevState,
      denunciaPol: e.target.checked,
    }));
    if (!check.denunciaPol) {
      setDocu(prevState => ({
        ...prevState,
        denunciaPol: 'Denuncia Pol \n',
      }));
    } else if (check.denunciaPol) {
      setDocu(prevState => ({
        ...prevState,
        denunciaPol: '',
      }));
    }
  }
  const responsabilidadInput = [
    { label: 'Cr', value: 320 },
    { label: 'Cc', value: 320 },
    { label: 'Sr', value: 300 },
    { label: 'Rp', value: 400 },
    { label: 'Rp1 (1 ruedas)', value: 401 },
    { label: 'Rp2 (2 ruedas)', value: 402 },
    { label: 'Rp3 (3 ruedas)', value: 403 },
    { label: 'Rp4 (4 ruedas)', value: 404 },
    { label: 'Rp5 (5 ruedas)', value: 405 },
    { label: 'Rt', value: 500 },
    { label: 'Ra', value: 550 },
    { label: 'Raf', value: 551 },
    { label: 'Ip', value: 600 },
    { label: 'Dp', value: 800 },
    { label: 'Dt', value: 900 },
    { label: 'Aseg les', value: 100 },
    { label: 'Aseg muerto', value: 130 },
    { label: '3ro les', value: 200 },
    { label: '3ro muerto', value: 230 },
    { label: '3ro muerto Rec', value: 233 },
    { label: 'Rah', value: 590 },
  ];
  const handleChange1 = event => {
    setResponsabilidad(event.target.value);
  };
  const stroRechazado = useCallback(
    async e => {
      e.preventDefault();
      Swal.fire({
        title: `Esta seguro que desea rechazar la denuncia ${denuncia.pza}`,
        icon: 'warning',
        confirmButtonText: 'Confirmar',
        showCancelButton: true,
      }).then(async result => {
        setOpacity(1);
        if (result.isConfirmed) {
          await axios.post(`https://back.agsseguros.online/api/actualizarEstadoRechazado`, { entryId: denuncia.entryId }).then(async res => {
            await axios
              .post(`https://back.agsseguros.online/api/cronologia`, {
                id: denuncia.id,
                desc: 'La denuncia ha sido rechazada',
                obs: obs,
                jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
                motivo: 'STRO',
                autor: cookies.user.usuario,
                fecha: formattedDate,
                hora: currentTime,
              })
              .then(() => {
                Swal.fire({
                  title: `La denuncia ${denuncia.pza} se ha catalogado como rechazado correctamente`,
                  icon: 'success',
                  confirmButtonText: 'oK',
                }).then(result => {
                  if (result.isConfirmed) {
                    window.location.reload();
                  }
                });
              });
          });
        } else if (result.isDenied) {
        }
      });
    },
    [denuncia, obs, currentTime, formattedDate, cookies]
  );
  const stroPosibleDuplicado = useCallback(
    async e => {
      e.preventDefault();
      Swal.fire({
        title: `Esta seguro que desea marcar como duplicado la denuncia ${denuncia.entryId}`,
        icon: 'warning',
        confirmButtonText: 'Confirmar',
        showCancelButton: true,
      }).then(async result => {
        setOpacity(1);
        if (result.isConfirmed) {
          await axios.post(`https://back.agsseguros.online/api/carga/cargarPosibleDuplicado`, { entryId: denuncia.entryId }).then(async res => {
            await axios
              .post(`https://back.agsseguros.online/api/cronologia`, {
                id: denuncia.id,
                desc: 'La denuncia ha sido marcada como duplicado',
                obs: obs,
                jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
                motivo: 'STRO',
                autor: cookies.user.usuario,
                fecha: formattedDate,
                hora: currentTime,
              })
              .then(() => {
                Swal.fire({
                  title: `La denuncia ${denuncia.entryId} se ha catalogado como duplicado correctamente`,
                  icon: 'success',
                  confirmButtonText: 'oK',
                }).then(result => {
                  if (result.isConfirmed) {
                    window.location.reload();
                  }
                });
              });
          });
        } else if (result.isDenied) {
        }
      });
    },
    [denuncia, obs, currentTime, formattedDate, cookies]
  );
  const stroAmpliacion = useCallback(
    async e => {
      e.preventDefault();
      Swal.fire({
        title: `Esta seguro que desea pedir ampliacion de la denuncia ${denuncia.pza}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
      }).then(async result => {
        setOpacity(1);
        if (result.isConfirmed) {
          Swal.fire(
            `Estimados, solicitamos que nos envíen la siguiente documentación faltante:`,
            `${docu.fotos} ${docu.cedula} ${docu.croquis} ${docu.relato} ${docu.danios} ${docu.registro} ${docu.denunciaPol} \n\n${docu.otros}`,
            'success'
          ).then(async () => {
            await axios
              .post(`https://back.agsseguros.online/api/cronologia`, {
                id: denuncia.id,
                desc: `Se ha solicitado la siguiente documentación: ${docu.fotos} ${docu.cedula} ${docu.croquis} ${docu.relato} ${docu.danios} ${docu.registro} ${docu.denunciaPol} \n\n${docu.otros}`,
                obs: obs,
                jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
                motivo: 'AMPL',
                autor: cookies.user.usuario,
                fecha: formattedDate,
                hora: currentTime,
              })
              .then(() => {
                window.location.reload();
              });
          });
        }
      });
    },
    [denuncia, docu, obs, cookies, currentTime, formattedDate]
  );
  const [fueCargado, setFueCargado] = useState(false);
  const stroCargado = useCallback(
    async e => {
      e.preventDefault();
      Swal.fire({
        title: `Esta seguro que desea cargar la denuncia ${denuncia.pza}`,
        icon: 'warning',
        confirmButtonText: 'Confirmar',
        showCancelButton: true,
      }).then(async result => {
        setOpacity(1);
        if (result.isConfirmed) {
          setFueCargado(true);
          Swal.fire({
            title: 'Cargando denuncia...',
            html: 'Por favor, espere mientras se procesan los datos.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          try {
            const res = await axios.post(`https://back.agsseguros.online/api/carga/cargarDenunciaNuevo`, {
              estado: Number(denuncia.estadoNuevo) !== 200 && Number(denuncia.estadoNuevo) !== 201 && Number(denuncia.estadoNuevo) !== 203 ? Number(denuncia.estadoNuevo) : 201,
              id: denuncia.id,
              responsabilidad: Number(responsabilidad),
              tipoStro: denuncia.tipoStro,
              cbtSicobe: cobert === 'CON COBERTURA' ? 1 : cobert === 'EN REVISION' ? 2 : 0,
            });
            await axios.post(`https://back.agsseguros.online/api/cronologia`, {
              id: denuncia.id,
              desc: 'El stro fue cargado correctamente',
              obs: obs,
              jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
              motivo: 'STRO',
              autor: cookies.user.usuario,
              fecha: formattedDate,
              hora: currentTime,
            });
            const nroStroLimpio = res.data.nroStro.toString().substring(3);
            try {
              await axios.post(`https://back.agsseguros.online/api/mail/mailNuevaCargaPas`, {
                id: denuncia.id,
                mail: res.data.email,
                pza: res.data.pza,
                patente: res.data.dom,
                fechaStro: formatDate(res.data.fechaStro),
                nroStro: nroStroLimpio,
              });
            } catch (mailError) {
              console.error('Error al enviar mail PAS:', mailError);
            }
            try {
              await axios.post(`https://back.agsseguros.online/api/mail/mailNuevaCargaPasAugusto`, {
                id: denuncia.id,
                pza: res.data.pza,
                patente: res.data.dom,
                fechaStro: formatDate(res.data.fechaStro),
                nroStro: nroStroLimpio,
              });
            } catch (mailAugustoError) {
              console.error('Error al enviar mail Augusto:', mailAugustoError);
            }
            // La carpeta de SharePoint se crea con el nro de denuncia; una vez generado el
            // siniestro pasa a llamarse "nroStro-poliza". No es crítico: si falla, la carga sigue.
            try {
              let linkCarpeta = denuncia.link;
              if (!linkCarpeta) {
                // Puede haberse vinculado recién, desde el módulo de documentos: se relee.
                const actual = await axios.get(`https://back.agsseguros.online/api/carga/pruebaCargaSinNada/${denuncia.id}`);
                linkCarpeta = actual.data?.link;
              }
              const nuevoNombre = nombreCarpetaStro(res.data.nroStro, res.data.pza);
              if (linkCarpeta && nuevoNombre) {
                const resRename = await renameSharepointFolder(linkCarpeta, nuevoNombre);
                if (!resRename.success) console.warn('No se pudo renombrar la carpeta de SharePoint:', resRename.error);
              }
            } catch (renameError) {
              console.error('Error al renombrar la carpeta de SharePoint:', renameError);
            }

            setDenunciaParaSicobe(nroStroLimpio);
            Swal.fire({
              title: `El Stro ${nroStroLimpio} se ha cargado correctamente`,
              icon: 'success',
              confirmButtonColor: '#42C3BA',
              confirmButtonText: 'Descargar Sicobe',
            }).then(result => {
              if (result.isConfirmed) {
                document.getElementById('botonSicobe').click();
              }
              window.location.reload();
            });
          } catch (error) {
            console.error('Error crítico en el proceso de carga:', error);
            Swal.fire({
              title: 'Error al procesar la carga',
              text: 'Hubo un inconveniente en el servidor.',
              icon: 'error',
            }).then(() => {
              window.location.reload();
            });
          }
        }
      });
    },
    [denuncia, obs, currentTime, formattedDate, cookies, responsabilidad, cobert]
  );
  function getLabelsFromValues(dbValue, responsabilidadInput) {
    const valuesArray = dbValue.split(',').map(Number);
    const labels = valuesArray
      .map(value => {
        const item = responsabilidadInput.find(item => item.value === value);
        return item ? item.label : null;
      })
      .filter(label => label !== null);
    return labels.join(', ');
  }
  useEffect(() => {
    if (alerta === 1 && !alerta1.current) {
      const duplicados = denuncia?.duplicados || [];
      const links = duplicados.map(d => `<a href="https://app.agsseguros.online/#/${d.id}" target="_blank">${d.entryId}</a>`).join('<br/>');
      Swal.fire({
        title: 'Posibles duplicados encontrados',
        html: `${links}`,
        icon: 'info',
        confirmButtonText: 'Aceptar',
      });
      setAlerta(0);
      alerta1.current = true; // Marca que la alerta ya se mostró
    }
  }, [alerta, denuncia]);
  const [planilla, setPlanilla] = useState(0);
  useEffect(() => {}, [theme]);
  return (
    <>
      {planilla === 0 ? (
        theme === 1 ? (
          <NuevoStroCargasLight
            stro={denuncia}
            carga4={carga4}
            reclamo={planillaReclamos}
            cargando={cargando}
            carga2={carga2}
            carga3={carga3}
            sicobe={sicobe}
            frente={frente}
            pagosAnteriores={pagosAnteriores1}
            cobert={cobert}
            estados={estados}
            estadosCodigos={estadosCodigos}
            getLabelsFromValues={getLabelsFromValues}
            responsabilidadInput={responsabilidadInput}
            responsabilidad={responsabilidad}
            handleChange1={handleChange1}
            setObs={setObs}
            obs={obs}
            stroAmpliacion={stroAmpliacion}
            stroRechazado={stroRechazado}
            stroCargado={stroCargado}
            stroPosibleDuplicado={stroPosibleDuplicado}
            docu={docu}
            handleChangeFotos={handleChangeFotos}
            handleChangeCedula={handleChangeCedula}
            handleChangeCroquis={handleChangeCroquis}
            handleChangeDanios={handleChangeDanios}
            handleChangeDenunciaPol={handleChangeDenunciaPol}
            handleChangeRegistro={handleChangeRegistro}
            handleChangeRelato={handleChangeRelato}
            setDocu={setDocu}
            check={check}
            denunciaParaSicobe={denunciaParaSicobe}
            setPlanilla={setPlanilla}
            planilla={planilla}
          />
        ) : (
          <NuevoStroCargasDark
            stro={denuncia}
            carga4={carga4}
            reclamo={planillaReclamos}
            cargando={cargando}
            carga2={carga2}
            carga3={carga3}
            sicobe={sicobe}
            frente={frente}
            pagosAnteriores={pagosAnteriores1}
            cobert={cobert}
            estados={estados}
            estadosCodigos={estadosCodigos}
            getLabelsFromValues={getLabelsFromValues}
            responsabilidadInput={responsabilidadInput}
            responsabilidad={responsabilidad}
            handleChange1={handleChange1}
            setObs={setObs}
            obs={obs}
            stroAmpliacion={stroAmpliacion}
            stroRechazado={stroRechazado}
            stroCargado={stroCargado}
            docu={docu}
            handleChangeFotos={handleChangeFotos}
            handleChangeCedula={handleChangeCedula}
            handleChangeCroquis={handleChangeCroquis}
            handleChangeDanios={handleChangeDanios}
            handleChangeDenunciaPol={handleChangeDenunciaPol}
            handleChangeRegistro={handleChangeRegistro}
            handleChangeRelato={handleChangeRelato}
            setDocu={setDocu}
            check={check}
            denunciaParaSicobe={denunciaParaSicobe}
            setPlanilla={setPlanilla}
            planilla={planilla}
          />
        )
      ) : (
        <Reclamo reclamo={reclamo3ro} stro={stro} planilla={planilla} setPlanilla={setPlanilla} denuncia={denuncia} carga4={carga4} reclamoPanel={planillaReclamos} />
      )}
      <AiChatWidget denuncia={denuncia} estados={estados} reclamos={reclamo3ro} reclamoSeleccionado={reclamo3ro} />
    </>
  );
}
